import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-306fbdba")

_pushScopeId("data-v-306fbdba")
const _hoisted_1 = { class: "carousel-button flex flex--valign-c flex--halign-c flex--gap-20" }
const _hoisted_2 = { class: "carousel-button-title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("No title"))
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TransitionWidth = _resolveComponent("TransitionWidth")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "carousel-button-icon text text--size-32 text--extra-bold text--accent-gray-a text--uppercase",
      disabled: _ctx.leftDisabled,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickLeft && _ctx.clickLeft(...args)))
    }, _toDisplayString("<"), 8, ["disabled"]),
    _createVNode(_component_TransitionWidth, null, {
      default: _withId(() => [
        _createVNode("span", _hoisted_2, [
          _createVNode(_Transition, {
            name: "generic-fade",
            mode: "out-in"
          }, {
            default: _withId(() => [
              (_openBlock(), _createBlock("span", {
                key: _ctx.selectedIndex,
                class: "carousel-button-title-inner text text--size-20 text--semi-bold text--primary-b text--uppercase text--less-gap"
              }, [
                _renderSlot(_ctx.$slots, "title", { selectedItem: _ctx.selectedItem }, () => [
                  _hoisted_3
                ], true)
              ]))
            ]),
            _: 3
          })
        ])
      ]),
      _: 1
    }),
    _createVNode("button", {
      class: "carousel-button-icon text text--size-32 text--extra-bold text--accent-gray-a text--uppercase",
      disabled: _ctx.rightDisabled,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickRight && _ctx.clickRight(...args)))
    }, _toDisplayString(">"), 8, ["disabled"])
  ]))
})